<div class="more-information">
  <ion-item lines="none">
    <p *ngIf="!loading" class="disclaimer" [ngClass]="font?.size" [innerHtml]="disclaimer | translate"></p>
    <ion-skeleton-text *ngIf="loading" class="skeleton-line" animated></ion-skeleton-text>
  </ion-item>
  <ion-button class="button primary" [ngClass]="font?.size" [disabled]="loading" (click)="goTo()">
    <span [class.hidden]="loading">{{ buttonText | translate }}</span>
  </ion-button>
</div>
